import React, { useEffect, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay } from "@fortawesome/free-solid-svg-icons";
import { getAllDropdowns } from "../../../../services/college";

const userSchema = yup.object().shape({
    state: yup.string(),
    city: yup.string(),
});

const IndianCollegeFilter = (props) => {
    const [dropdowns, setDropdowns] = useState([]);
    const [stateId, setStateId] = useState("");


    useEffect(() => {
        getDropdowns();
    }, [])
    const {
        register,
        reset,
        handleSubmit,
    } = useForm({ resolver: yupResolver(userSchema) });

    const onSubmit = handleSubmit((values) => {
        let payload = {
            state: values?.state,
            city: values?.city,
        }
        props.setFilterData(payload);
        props.onHide()
    });

    const getDropdowns = async () => {
        let response = await getAllDropdowns("state,city");
        setDropdowns(response?.data?.result);
    }


    return (
        <div className="wrapper-assignpage">
            <Modal
                className="assign-modal"
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <form onSubmit={onSubmit}>
                    <Modal.Header className="text-center d-block ">
                        <Modal.Title id="contained-modal-title-vcenter" className="f-14">
                            Indian College Filter
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="wrapper-assignpage">
                            <div className="dashboard">
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="itemselected-bx">
                                            <label> <FontAwesomeIcon className="adminplayicon" icon={faPlay} />State</label>
                                            <Form.Select className="form-control select-selected"  {...register("state", {
                                                onChange: (e) => {
                                                    setStateId(e.target.value);
                                                }
                                            })}>
                                                <option value="">Select State</option>
                                                {dropdowns?.state?.map((list) => (
                                                    <option value={list.state_id}>{list.state}</option>
                                                ))}
                                            </Form.Select>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="itemselected-bx">
                                            <label> <FontAwesomeIcon className="adminplayicon" icon={faPlay} />City</label>
                                            <Form.Select className="form-control select-selected"  {...register("city")}>
                                                <option value="">Select City</option>
                                                {dropdowns?.city?.filter(item => (item.state_id === parseInt(stateId) || !stateId))?.map((list) => (
                                                    <option value={list.city}>{list.city}</option>
                                                ))}
                                            </Form.Select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer className="d-flex justify-content-center mt-4">
                        <button type="button" className=" cancel-btn add-btn" onClick={() => {
                            reset();
                            props.onHide();
                        }}>Discard </button>
                        <button className="save-btn add-btn" id="saveButton"
                            type="submit"
                        >Apply</button>
                        <button type="submit" className=" cancel-btn add-btn" onClick={() => {
                            reset();
                            props.onHide();
                        }}>Reset </button>
                    </Modal.Footer>
                </form>
            </Modal>
        </div>
    )
}

export default IndianCollegeFilter;